<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"> {{ $t("messages.titTempHumidStatus") }} </span>
      <idc-popover placment="right">
        <template #content>
          <div class="popover-content">
            <p class="info">
              {{ $t("messages.txtTemperature") }}
            </p>
            <div class="info-content">
              <p class="title color-primary">
                {{ $t("messages.titTemperature") }}
              </p>
              <p class="contents">{{ $t("messages.txtTemperatureInfo") }}</p>
            </div>
          </div>
        </template>
      </idc-popover>
    </div>
    <div class="table-body">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">{{ totalSize }}</span
            >{{ $t("messages.unit") }}
          </p>
          <!--
          <div class="sort-select">
            <el-select
              size="medium"
              v-model="count"
              :placeholder="$t('messages.plCount25')"
            >
              <el-option
                v-for="item in countList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span>
              {{ $t("messages.perShow") }}
            </span>
          </div> -->
        </div>
        <div v-if="!$isMobile()">
          <el-button size="small" type="save" @click="openGraphModal">{{
            $t("messages.btnTempHumidGraph")
          }}</el-button>

          <el-button plain size="small" type="excel"
            >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
          ></el-button>
        </div>
      </div>
      <idc-list :tableHeader="tableHeader" :tableData="tableData" @clickRow="clickRow"> </idc-list>
    </div>
    <!--modal-->
    <idc-modal
      :visible.sync="modalTraffic"
      :title="$t('messages.titTempHumidStatus')"
      width="1410px"
      top="2vh"
    >
      <template #content>
        <!-- <div class="graph">
          <div class="graph-title">
            {{ $t("messages.titChartDaily") }}
          </div>
          <div class="graph-area graph-area-daily"></div>
          <div class="graph-list">
            <ul>
              <li>
                {{ $t("messages.max") }} <b>Forward</b> :
                <span>27.2 Mb/s (2.7%)</span>
              </li>
              <li>
                {{ $t("messages.max") }} <i>Drop</i> :
                <span>11.7 Mb/s (1.2%)</span>
              </li>
            </ul>
            <ul>
              <li>
                {{ $t("messages.average") }} <b>Forward</b> :
                <span>10.7 Mb/s (1.1%)</span>
              </li>
              <li>
                {{ $t("messages.average") }} <i>Drop</i> :
                <span>4.2 Mb/s (.4%)</span>
              </li>
            </ul>
            <ul>
              <li>
                {{ $t("messages.current") }} <b>Forward</b> :
                <span>11.6 Mb/s (1.2%)</span>
              </li>
              <li>
                {{ $t("messages.current") }} <i>Drop</i> :
                <span>3.9 Mb/s (.4%)</span>
              </li>
            </ul>
          </div>
        </div>
        <el-divider></el-divider> -->
        <div class="graph">
          <div class="graph-title">
            {{ $t("messages.titChartWeekly") }}
          </div>
          <div class="graph-area graph-area-weekly"></div>
          <div class="graph-list">
            <ul>
              <li>
                {{ $t("messages.max") }} <b>Forward</b> :
                <span>27.2 Mb/s (2.7%)</span>
              </li>
              <li>
                {{ $t("messages.max") }} <i>Drop</i> :
                <span>11.7 Mb/s (1.2%)</span>
              </li>
            </ul>
            <ul>
              <li>
                {{ $t("messages.average") }} <b>Forward</b> :
                <span>10.7 Mb/s (1.1%)</span>
              </li>
              <li>
                {{ $t("messages.average") }} <i>Drop</i> :
                <span>4.2 Mb/s (.4%)</span>
              </li>
            </ul>
            <ul>
              <li>
                {{ $t("messages.current") }} <b>Forward</b> :
                <span>11.6 Mb/s (1.2%)</span>
              </li>
              <li>
                {{ $t("messages.current") }} <i>Drop</i> :
                <span>3.9 Mb/s (.4%)</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </idc-modal>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import IdcModal from "@/components/common/IdcModal.vue";
import IdcPopover from "@/components/common/IdcPopover.vue";

import jui from "jui-chart/lib/core.min.js";
import "jui-chart/dist/chart.min.js";

export default {
  components: {
    IdcList,
    IdcModal,
    IdcPopover,
  },
  mounted() {
    for (let i = 0; i < 5; i++) {
      this.tableData.push({
        col2: "목동1",
        col3: "1-A",
        col4: "01",
        col5: "표준랙",
        col6: "700kWh",
        col7: "500kWh",
        col8: "450kWh",
        col9: "600kWh",
        col10: "700kWh",
      });
    }
    this.totalSize = 5;
  },
  computed: {
    tableHeader() {
      return [
        {
          type: "index",
          label: "NO",
          width: "5",
        },
        {
          prop: "col2",
          label: "IDC",
          width: "10",
        },
        {
          prop: "col3",
          //label: "ROOM명",
          label: this.$t("messages.lblRoomName"),
          width: "10",
        },
        {
          prop: "col4",
          //label: "RACK번호",
          label: this.$t("messages.lblRackNumber"),
          width: "10",
        },
        {
          prop: "",
          //label: "현재온도",
          label: this.$t("messages.lblCurrentTemperature"),
          width: "10",
        },
        {
          prop: "",
          //label: "온도",
          label: this.$t("messages.titTemper") + "(min)",
          width: "10",
        },
        {
          prop: "",
          //label: "온도",
          label: this.$t("messages.titTemper") + "(max)",
          width: "10",
        },
        {
          prop: "",
          //label: "온도",
          label: this.$t("messages.titTemper") + "(avg)",
          width: "10",
        },
        {
          prop: "",
          //label: "현재 습도",
          label: this.$t("messages.lblCurrentHumidity"),
          width: "10",
        },
        {
          prop: "",
          //label: "습도",
          label: this.$t("messages.lblHumidity") + "(min)",
          width: "10",
        },
        {
          prop: "",
          //label: "습도",
          label: this.$t("messages.lblHumidity") + "(max)",
          width: "10",
        },
        {
          prop: "",
          //label: "습도",
          label: this.$t("messages.lblHumidity") + "(avg)",
          width: "10",
        },
        // {
        //   prop: "col5",
        //   //label: "RACK유형",
        //   label: this.$t("messages.lblRackType"),
        //   width: "10",
        // },
        // {
        //   prop: "col6",
        //   //label: "계약전력",
        //   label: this.$t("messages.lblContractPower"),
        //   width: "15",
        // },
        // {
        //   prop: "col7",
        //   //label: "현재전력",
        //   label: this.$t("messages.lblCurrentPower"),
        //   width: "15",
        // },
        // {
        //   prop: "col8",
        //   //label: "전력(min)",
        //   label: this.$t("messages.lblPowerMin"),
        //   width: "15",
        // },
        // {
        //   prop: "col9",
        //   //label: "전력(avr)",
        //   label: this.$t("messages.lblPowerAvr"),
        //   width: "15",
        // },
        // {
        //   prop: "col10",
        //   //label: "전력(max)",
        //   label: this.$t("messages.lblPowerMax"),
        //   width: "15",
        // },
      ];
    }
  },
  data() {
    return {
      totalSize: 0,
      count: "10",
      countList: [
        {
          value: 25,
          label: "25개",
        },
        {
          value: 50,
          label: "50개",
        },
      ],
      tableData: [],
      modalTraffic: false,
      currentRow: {},
      grapCustId: "",
      weeklyChart: null
    };
  },
  methods: {
    clickRow(row) {
      this.currentRow = row;
    },
    async getTempr7D(itemId) {
      const { data } = await this.$BIZ_SERVICE.post(this.$API_URLS.Com.getTempr7D, { itemId: itemId, });
      if (data.resData.length > 0) {
        return data.resData;
      }
      return [];
    },
    async openGraphModal() {
      if (Object.keys(this.currentRow).length === 0) {
        alert(this.$t('messages.msgSelectTempHumid'));
        return;
      }
      const legend2 = { temprAvgUseQnt: "온도", humdtAvgUseQnt: "습도" };
      const temprDomain = [0, 100];
      const humdtDomain = [0, 100];

      let chart2Data = [];
      const data2 = await this.getTempr7D('mok1facility875');
      if (data2.length > 0) {
        var arrTemprAvgUseQnt = [];
        var arrHumdtAvgUseQnt = [];
        for (var tmp of data2) {
          arrTemprAvgUseQnt.push(tmp.temprAvgUseQnt);
          arrHumdtAvgUseQnt.push(tmp.humdtAvgUseQnt);
          chart2Data.push(Object.assign(tmp, {
            temprAvgUseQnt: tmp.temprAvgUseQnt,
            humdtAvgUseQnt: tmp.humdtAvgUseQnt,
          }));
        }
        //temprDomain[0] = Math.floor(Math.min(...arrTemprAvgUseQnt)) - 5;
        //temprDomain[1] = Math.floor(Math.max(...arrTemprAvgUseQnt)) + 5;
         //humdtDomain[0] = Math.floor(Math.min(...arrHumdtAvgUseQnt)) - 5;
         //humdtDomain[1] = Math.floor(Math.max(...arrHumdtAvgUseQnt)) + 5;
      }
      setTimeout(() => {
        this.setChart3(chart2Data, this.chartCategoryForamtterByYmd, legend2, temprDomain, humdtDomain, "colecDt", ["temprAvgUseQnt", "humdtAvgUseQnt"])
      }, 300);
      this.modalTraffic = true;
    },
    setChart3(data, categoryFormatter, legend, domain1, domain2, categolyName, axisNames) {
      if (this.weeklyChart == null) {
        let chart = jui.include("chart.builder");
        this.weeklyChart = chart(".graph-area-weekly", {
          axis: [
            {
              x: {
                type: "fullblock",
                domain: categolyName,
                line: "soild",
                textRotate: 0,
                format: categoryFormatter,
              },
              y: {
                type: "range",
                domain: domain1,
                line: "solid",
                step: 5,
              },
              data: data,
            },
            {
              x: {
                hide: true,
              },
              y: {
                type: "range",
                orient: "right",
                domain: domain2,
                line: "solid",
                step: 5,
              },
              extend: 0
            },
          ],
          brush: [
            {
              type: "line",
              axis: [0],
              target: axisNames[0],
              colors: ["#ffa95a"],
              animate: true,
            },
            {
              type: "line",
              axis: [1],
              target: axisNames[1],
              colors: ["#d1f6e9"],
              animate: true,
            },
          ],
          widget: [
            {
              type: "legend",
              brush: [0, 1],
              format: function (k) {
                return legend[k];
              },
            },
          ],
          style: {},
        });
      }
      else {
        this.weeklyChart.axis(0).update(data)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ly-sort-his {
  //공통 / 삭제
  display: flex;
  padding: 0 0 10px 0;
  justify-content: space-between;
  align-items: center;
  .table-cell {
    &-all {
      font-size: $--font-size-base;
      line-height: 26px;
      display: inline-block;
      vertical-align: middle;
    }
    &-count {
      margin-left: 8px;
      font-weight: $--font-weight-bold;
    }
    &-notice {
      //추가
      margin-left: 32px;
      color: $--color-success;
      list-style-type: disc;
    }
  }
  .sort {
    &-count {
      display: flex;
      align-items: center;
    }
    &-select {
      display: inline-block;
      vertical-align: middle;
      color: $--color-black;
      .el-select {
        display: inline-block;
        vertical-align: middle;
        width: 80px;
        margin: 0 8px;
      }
      span {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
.graph {
  .graph {
    &-title {
      margin: 20px 0 0 0;
      font-size: $--font-size-medium;
      font-weight: $--font-weight-Medium;
      position: relative;
      z-index: 3;
    }
    &-area {
      height: 380px;
      margin-top: -30px;
    }
    &-list {
      width: 800px;
      height: 50px;
      margin: 0 0 20px 25px;
      ul {
        width: 33%;
        float: left;
      }
      li {
        display: list-item;
        list-style-type: disc;
        margin-top: 5px;
        b {
          color: $--color-primary;
        }
        i {
          color: $--work-flow-pend-background-color;
        }
      }
    }
  }
}
.popover-content {
  .info {
    white-space: pre;
    padding-bottom: 10px;
  }
}
</style>
